import { axiosInstance } from '../../../common/axiosInstans.ts';
import { AmbulanceTransactionForm } from '../../../application/types/form/ambulanceTransactionForm.ts';
import { ShiftChangeInventorySlice } from '../../../application/store/createShiftChangeInventorySlice.ts';
import { TransactionFormData } from '../../../application/store/createTransactionFormSlice.ts';
import { TransactionType } from '../../../application/types/transactionType.ts';
import {
    DoubleSignatureData,
    InventoryDoubleSignatureData,
} from '../../../application/types/doubleSignatureData.ts';

class TransactionService {
    async saveDoubleSignature(doubleSignature: DoubleSignatureData) {
        try {
            let endpoint = '/transaction/';

            return await axiosInstance.patch(endpoint, doubleSignature);
        } catch (error) {
            if (error.response) {
                console.error('Error response from API:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error during API call:', error.message);
            }
            throw error;
        }
    }

    async saveInventoryDoubleSignature(
        inventoryDoubleSignature: InventoryDoubleSignatureData
    ) {
        try {
            const endpoint = '/transaction/double-signing';

            return await axiosInstance.patch(
                endpoint,
                inventoryDoubleSignature
            );
        } catch (error) {
            if (error.response) {
                console.error('Error response from API:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error during API call:', error.message);
            }
            throw error;
        }
    }

    async saveTransaction(
        transactionFormData:
            | AmbulanceTransactionForm
            | TransactionFormData
            | ShiftChangeInventorySlice,
        transactionType: TransactionType
    ) {
        // The transactionType is used to determine which API endpoint to call and how to structure the data
        if (transactionType === TransactionType.AmbulanceTransaction) {
            try {
                return await axiosInstance.post(
                    '/transaction/connected-transaction',
                    JSON.stringify(transactionFormData),
                    { headers: { 'Content-Type': 'application/json' } }
                );
            } catch (error) {
                if (error.response) {
                    console.error(
                        'Error response from API:',
                        error.response.data
                    );
                } else if (error.request) {
                    console.error('No response received:', error.request);
                } else {
                    console.error('Error during API call:', error.message);
                }
                throw error;
            }
        } else if (transactionType === TransactionType.ShiftCrosscheck) {
            try {
                return await axiosInstance.post(
                    '/transaction/crosscheck-shift-change',
                    JSON.stringify(transactionFormData),
                    { headers: { 'Content-Type': 'application/json' } }
                );
            } catch (error) {
                if (error.response) {
                    console.error(
                        'Error response from API:',
                        error.response.data
                    );
                } else if (error.request) {
                    console.error('No response received:', error.request);
                } else {
                    console.error('Error during API call:', error.message);
                }
                throw error;
            }
        } else if (transactionType === TransactionType.Crosscheck) {
            try {
                return await axiosInstance.post(
                    '/transaction/inventory',
                    JSON.stringify(transactionFormData),
                    { headers: { 'Content-Type': 'application/json' } }
                );
            } catch (error) {
                if (error.response) {
                    console.error(
                        'Error response from API:',
                        error.response.data
                    );
                } else if (error.request) {
                    console.error('No response received:', error.request);
                } else {
                    console.error('Error during API call:', error.message);
                }
                throw error;
            }
        } else {
            // api = /api/v1/transaction
            // data sent to API should look like this src/application/types/requests/createTransactionRequest.ts
            try {
                return await axiosInstance.post(
                    '/transaction',
                    JSON.stringify(transactionFormData),
                    { headers: { 'Content-Type': 'application/json' } }
                );
            } catch (error) {
                if (error.response) {
                    console.error(
                        'Error response from API:',
                        error.response.data
                    );
                } else if (error.request) {
                    console.error('No response received:', error.request);
                } else {
                    console.error('Error during API call:', error.message);
                }
                throw error;
            }
        }
    }
}

export default new TransactionService();
